<template>
  <div>
    <page-header title="ساخت ویژگی جدید محصول"></page-header>

    <crud-generator :fields="fields" @submit="submit" name="Specifications"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "CreateSpecification",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [
        {
          name: 'fa_name',
          label: 'نام',
          cols: 4,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'en_name',
          label: 'Name',
          cols: 4,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'type',
          label: 'Type',
          cols: 4,
          type: 'select',
          select_items: [
            {text: 'بله / خیر', value: 'BOOLEAN'},
            {text: 'عدد', value: 'NUMBER'},
            {text: 'متن', value: 'STRING'},
          ],
          select_value: 'value',
          select_text: 'text',
        },
        {
          name: 'searchable',
          label: 'قابل جستجو',
          cols: 2,
          type: 'checkbox',
        },
      ],
      selectedSpecifications: [],
    }
  },

  methods: {
    submit(values) {
      this.$store.dispatch("createSpecification", values)
          .then(() => {
            this.$router.push('/Specifications')
          })
    },

    specificationsUpdated(values) {
      this.selectedSpecifications = values
    }
  }
}
</script>

<style scoped>

</style>